import { PageLayout } from "../components/PageLayout";
import { useDocumentMeta } from "../lib/router";

export function DisclaimerPage() {
  useDocumentMeta({
    title: "免責事項 | 食べログ ラーメン百名店マップ",
    description:
      "食べログ ラーメン百名店マップの免責事項です。掲載情報の正確性・最新性、リンク先サイト、第三者サービスに関する免責について定めています。",
  });

  return (
    <PageLayout title="免責事項" lastUpdated="2026-04-13">
      <p>
        本免責事項は、食べログ ラーメン百名店マップ (以下「本サイト」といいます)
        の利用に伴う責任の所在について定めるものです。
      </p>

      <h2>1. 情報の正確性について</h2>
      <p>
        本サイトに掲載されている店舗情報 (選出年、店名、住所、座標、評価、
        営業時間、写真等) は、運営者がデータ収集時点で確認できた情報に
        基づいていますが、その正確性・最新性・完全性・有用性を保証する
        ものではありません。掲載情報の誤り、遅延、欠落等により発生した
        いかなる損害についても、運営者は一切の責任を負いません。
      </p>
      <p>
        実際に店舗を訪問する際は、必ず店舗の公式情報・電話確認・食べログや
        Google Maps 上の最新情報をご確認ください。
      </p>

      <h2>2. 閉店・移転・リニューアル情報について</h2>
      <p>
        閉店・移転・リニューアルのステータスは運営者が手動で管理して
        います。反映に遅延が生じることがあり、現地の実情と一致しない
        場合があります。誤り・最新化の情報提供があれば随時修正いたします。
      </p>

      <h2>3. 食べログ株式会社との関係</h2>
      <p>
        本サイトは食べログ株式会社および株式会社カカクコムとは一切関係
        のない個人運営の非公式サイトです。食べログ株式会社の公式見解
        を表明するものではありません。
      </p>

      <h2>4. Google Maps Platform 由来のデータ</h2>
      <p>
        本サイトに表示される地図、座標、住所、評価、写真、営業時間等の
        情報は Google Maps Platform から取得したものであり、これらの情報の
        正確性・最新性については Google LLC のサービス品質に依存します。
      </p>

      <h2>5. 外部リンクについて</h2>
      <p>
        本サイトには食べログの個別店舗ページや Google Maps などの外部
        サイトへのリンクが含まれています。リンク先のサイトは第三者が
        管理・運営しているものであり、その内容について本サイト運営者は
        一切の責任を負いません。
      </p>

      <h2>6. 著作権・商標について</h2>
      <p>
        「食べログ」「ラーメン百名店」は食べログ株式会社または株式会社
        カカクコムの商標または登録商標です。「Google」「Google Maps」は
        Google LLC の商標または登録商標です。本サイト内でこれらの名称を
        使用しているのは、内容の説明および検索性の確保のためであり、
        権利侵害の意図はありません。
      </p>

      <h2>7. 損害賠償責任の制限</h2>
      <p>
        本サイトの利用に関連して生じたいかなる直接的・間接的損害
        (逸失利益、データ損失、業務中断等を含みますがこれに限られません)
        についても、運営者は一切の賠償責任を負わないものとします。
      </p>

      <h2>8. 免責事項の変更</h2>
      <p>
        運営者は、必要と判断した場合には、ユーザーに通知することなく
        本免責事項を変更することができるものとします。
      </p>
    </PageLayout>
  );
}
